import { render, staticRenderFns } from "./CodesList.vue?vue&type=template&id=8e50106c&scoped=true&"
import script from "./CodesList.vue?vue&type=script&lang=js&"
export * from "./CodesList.vue?vue&type=script&lang=js&"
import style0 from "./CodesList.vue?vue&type=style&index=0&id=8e50106c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e50106c",
  null
  
)

export default component.exports